import { render, staticRenderFns } from "./competitionRules.vue?vue&type=template&id=2499ca2c&scoped=true&lang=html&"
import script from "./competitionRules.vue?vue&type=script&lang=js&"
export * from "./competitionRules.vue?vue&type=script&lang=js&"
import style0 from "./competitionRules.vue?vue&type=style&index=0&id=2499ca2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2499ca2c",
  null
  
)

export default component.exports